module.exports = __webpack_public_path__ + "img/hair_back_male_medium_mask.05d51865.png";